import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const VEHICLE_DETAILS = gql`
  query getVehicleInfoForWormwood(
    $market: MarketType!
    $lang: String!
    $id: String!
    $version: String
  ) {
    getVehicleInfoForWormwood(market: $market, lang: $lang, id: $id, version: $version) {
      modelID
      audiCode
      stockNumber
      vehicleType
      modelName
      modelMake
      modelPrice
      modelYear
      driveType
      isAvailableNow
      typedPrices {
        type
        formatted
        amount
      }
      warrantyType
      dealerId
      dealerName
      dataSource
      rebate {
        Name
        Value
        IdentCode
        offerDescription
        offerEndDate
        offerStartDate
      }
    }
  }
`;

export const GET_FILTERED_VEHICLES = gql`
  query getFilteredVehiclesForWormwood(
    $version: String
    $market: [MarketType]!
    $limit: Int
    $lang: String!
    $filters: String
    $ranges: String
    $sort: String
    $offset: Int
    $preset: String
  ) {
    getFilteredVehiclesForWormwood(
      version: $version
      market: $market
      size: $limit
      lang: $lang
      filters: $filters
      ranges: $ranges
      sort: $sort
      from: $offset
      preset: $preset
    ) {
      filterResults {
        totalCount
      }
      vehicles {
        vin
        id
      }
    }
  }
`;
